export const DEFAULT_SETTLE_AGREEMENT = "TT00";

export const settleAgreementOptions = Array.from({ length: 25 }, (_, index) => {
  const value = `TT${String(index * 5).padStart(2, "0")}`;

  return {
    label: value,
    value,
  };
});
